import { Form, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { webServiceProvider } from 'shared';
import styled from 'styled-components';
import ShopStore from '../../stores/ShopStore';

const { Option } = Select;

const NewName = styled.div`
  color: blue;
`;

const ServiceName = ({ form, initialValues }) => {
  const shopId = ShopStore.currentShop.id;

  const predefinedOptions =
    shopId === 1369 // Only for Tim Horton's Kingston
      ? [
          'CTI - commercial trailer inspection',
          'T1 - dry service on trailers - grease job',
          'CVI - commercial vehicle inspection',
          'LMI - lite maintenance interval – dry service',
          'ME1 - wet service on medium duty equipment - straight truck',
          'DE1 - wet service on heavy duty equipment (trucks) - fluid changes (oil)',
          'Damage',
          'Other',
        ]
      : [];

  const [filteredOptions, setFilteredOptions] = useState(predefinedOptions);
  const [inputValue, setInputValue] = useState(undefined);
  const [showSaveOption, setShowSaveOption] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchOptions = async () => {
    setLoading(true);
    try {
      const response = await webServiceProvider.get(
        `v1/car/serviceName/${shopId}`
      );
      if (response?.data) {
        setFilteredOptions([
          ...predefinedOptions,
          ...(Array.isArray(response.data) ? response.data : []),
        ]);
      } else {
        setFilteredOptions([...predefinedOptions]);
      }
    } catch {
      message.error('Failed to fetch service options');
    } finally {
      setLoading(false);
    }
  };

  const saveOption = async (newOption) => {
    setLoading(true);
    try {
      await webServiceProvider.post('v1/car/serviceName', {
        shopId,
        name: newOption,
      });
      setFilteredOptions((prev) => [...prev, newOption]);
      message.success('Service option saved successfully');
    } catch {
      message.error('Failed to save new service option');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [shopId]);

  const handleSearch = (value) => {
    setInputValue(value);

    if (!value) {
      fetchOptions();
      setShowSaveOption(false);
      return;
    }

    const filtered = filteredOptions.filter((opt) =>
      opt.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);
    setShowSaveOption(
      !filteredOptions.some((opt) => opt.toLowerCase() === value.toLowerCase())
    );
  };

  const handleSelect = async (value) => {
    if (value === `save_${inputValue}`) {
      await saveOption(inputValue);
      setShowSaveOption(false);
      form.setFieldsValue({ serviceName: inputValue });
      fetchOptions();
    }
  };

  const handleBlur = (e) => {
    const value = e.target.value;
    if (value === `save_${inputValue}`) {
      form.setFieldsValue({ serviceName: '' });
      fetchOptions();
    }
  };

  return (
    <Form.Item
      label={<span style={{ fontWeight: 'bold' }}>Service Name:</span>}
      name="serviceName"
      rules={[{ required: true, message: 'Service name is required' }]}
      initialValue={initialValues?.action}
    >
      <Select
        showSearch
        placeholder="Start typing to add new services..."
        onSearch={handleSearch}
        onSelect={handleSelect}
        value={inputValue}
        defaultValue={initialValues?.action}
        filterOption={false}
        onBlur={handleBlur}
        loading={loading}
      >
        {filteredOptions.map((option) => (
          <Option key={option} value={option}>
            {option}
          </Option>
        ))}
        {showSaveOption && inputValue && (
          <Option key={`save_${inputValue}`} value={`save_${inputValue}`}>
            <NewName>Save "{inputValue}"</NewName>
          </Option>
        )}
      </Select>
    </Form.Item>
  );
};

export default ServiceName;
